import styled from 'styled-components';

import { media } from '../../../styles/helpers';

const BadgeOnMobile = media.mobile`
  width: 160px;
  height: 160px;
  font-size: 40px;
  right: -40px;
  top: -40px;
  display: flex;
  align-items: center;
  font-weight: 700;
  text-transform: uppercase;
  background-color: #fff200;
  text-align: center;
  justify-content: center;
  transform: rotate(-11deg);
  position: absolute;
  z-index: 3;
  border-radius: 50%;
`;

export const BadgeWrapper = styled('div')`
  display: none;
  ${BadgeOnMobile}
`;
